(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["delivery"] && !Shopify.designMode) return;
  try {
    
const holidays = ['2025-04-15', '2025-04-16', '2025-05-02', '2025-06-04']; // Extend this list

function isBusinessDay(date) {
  const day = date.getDay(); // 0=Sun, 5=Fri, 6=Sat
  const iso = date.toISOString().split('T')[0];
  return day !== 5 && day !== 6 && !holidays.includes(iso);
}

function calculateDeliveryDate(startDate, businessDays = 3) {
  const date = new Date(startDate);
  let count = 0;
  while (count < businessDays) {
    date.setDate(date.getDate() + 1);
    if (isBusinessDay(date)) count++;
  }
  return date.toLocaleDateString('he-IL');
}

document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.delivery-section');
  if (!container) return;

  let days = 3; // default

  const value = Number(container.dataset.deliveryDays);
  if (!Number.isNaN(value)) {
    days = value;
  }

  const result = calculateDeliveryDate(new Date(), days);
  const target = document.getElementById('delivery-date');
  if (target) target.innerText = result;
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-faq-delivery"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('shopify:section:load', runDeliveryScript);
document.addEventListener('DOMContentLoaded', runDeliveryScript);

function runDeliveryScript() {
  const container = document.querySelector('.delivery-boxes');
  if (!container) return;

  let days = 3; // default

  const value = Number(container.dataset.deliveryDays);
  if (!Number.isNaN(value)) {
    days = value;
  }

  const result = calculateDeliveryDate(new Date(), days);
  const target = container.querySelector('#delivery-date');
  if (target) target.innerText = result;
}


  } catch(e) { console.error(e); }
})();
})();
